<template>
    <div>
      <el-form label-width="170px">
        <el-row>
          <panel title="应收质押信息" border>
            <el-col :span="12">
              <el-form-item label="质押申请编号：">
                {{detailData.pl__applicationNo}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="质押状态：">
                {{detailData.pl__applicationStatus|Status2CN}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客户名称：">
                {{detailData.ct__customerName}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="供应链：">
                {{detailData.ct__debtorName}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="额度核定书金额：">
                {{detailData.ct__lineOfCredit}} 元
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="可用额度：">
                {{detailData.ct__lineOfCredit}} 元
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="合同起始日：">
                {{detailData.ct__contractValidity1|moment('YYYY-MM-DD')}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="合同到期日：">
                {{detailData.ct__contractValidity2|moment('YYYY-MM-DD')}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="服务费：">
                {{detailData.ct__lendingFee}} {{detailData.ct__lendingFeeType=='Rate' ? '%' : '元'}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="融资利率：">
                {{detailData.ct__interestRate}} % ({{detailData.ct__interestType|Status2CN}})
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="服务费收取方式：">
                {{detailData.ct__lendingFeeType|Status2CN}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="利息收取节点：">
                {{detailData.ct__interestPayTime}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="费用收取节点：">
                {{detailData.ct__lendingFeePayTime}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="融资比例 ：">
                {{detailData.ct__financingRatio}} %
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="通知方式：">
                {{detailData.pl__channel}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="质押日期：">
                {{detailData.pl__pledgeDate|moment('YYYY-MM-DD')||'&nbsp;'}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="本次转让发票总额：">
                {{detailData.pl__pledgeAmount}} 元
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="本次转让发票数量：">
                {{detailData.invoices.length}}
              </el-form-item>
            </el-col>

          </panel>
        </el-row>
      </el-form>
      <panel title="应收账款列表">
        <invoices-data-table :invoices="detailData.invoices" :columns="invoiceColumns"/>
      </panel>
      <panel title="附件列表">
        <files-data-table :files="detailData.files" :additional-columns="[{label: '单据号码', field:'pa__invoiceNo'}]"/>
      </panel>
    </div>
</template>

<script>
  import Panel from '../../components/Panel'
  import InvoicesDataTable from './InvoicesDataTable'
  import FilesDataTable from '../../components/FilesDataTable'

  export default {
    name: "PledgeApplyingDetailComponent",
    data() {
      return {
        invoiceColumns: [
          {
            name: '单据类型',
            field: 'pi__invoiceType'
          },
          {
            name: '单据号码',
            field: 'pi__invoiceNo'
          },
          {
            name: '单据金额',
            field: 'pi__totalAmount',
          },
          {
            name: '质押金额',
            field: 'pi__pledgeAmount'
          },
          {
            name: '币种',
            field: 'pi__currencyCode',
            formatter: function(r,c,v) {
              return '人民币'
            }
          },
          {
            name: '单据日期',
            field: 'pi__invoiceDate',
          },
          {
            name: '到期日',
            field: 'pi__dueDate',
          }
        ]
      }
    },
    props: {
      detailData: {
        type: Object,
        default: ()=>{
          return {
            invoices: [],
            files: []
          }
        }
      },
    },
    components: {
      Panel,
      InvoicesDataTable,
      FilesDataTable
    },

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/PledgeApplyingDetailComponent.vue